// Centralized formatting helpers — BDT currency, dates, numbers
// fmtBDT  — compact, used everywhere in the admin panel:
//   <  1,000      → ৳523 BDT
//   ≥  1,000      → ৳1.5k BDT
//   ≥  100,000    → ৳1.2L BDT
//   ≥10,000,000   → ৳3.5Cr BDT
// Use fmtBDTExact() when you need the full-precision figure (edit modals,
// balance settings, PDFs that go to legal/finance, etc).
const _stripTrailingZero = (s) => s.replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");

export const fmtBDT = (n) => {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (abs >= 1e7) return `${sign}৳${_stripTrailingZero((abs / 1e7).toFixed(2))}Cr BDT`;
  if (abs >= 1e5) return `${sign}৳${_stripTrailingZero((abs / 1e5).toFixed(2))}L BDT`;
  if (abs >= 1e3) return `${sign}৳${_stripTrailingZero((abs / 1e3).toFixed(2))}k BDT`;
  return `${sign}৳${abs.toLocaleString("en-IN", { maximumFractionDigits: 2 })} BDT`;
};

// Full-precision figure (৳12,345.67 BDT) — for edit modals & exact balance display.
export const fmtBDTExact = (n) => {
  const num = Number(n || 0);
  return `৳${num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} BDT`;
};

// Compact form for chart axes (no "BDT" suffix). Same scale as fmtBDT.
export const fmtBDTShort = (n) => {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (abs >= 1e7) return `${sign}৳${_stripTrailingZero((abs / 1e7).toFixed(2))}Cr`;
  if (abs >= 1e5) return `${sign}৳${_stripTrailingZero((abs / 1e5).toFixed(2))}L`;
  if (abs >= 1e3) return `${sign}৳${_stripTrailingZero((abs / 1e3).toFixed(1))}k`;
  return `${sign}৳${abs.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

// Compact counts: 1.2k, 3.4M, etc. — for big-count stat tiles.
export const fmtNumCompact = (n) => {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (abs >= 1e7) return `${sign}${_stripTrailingZero((abs / 1e7).toFixed(2))}Cr`;
  if (abs >= 1e5) return `${sign}${_stripTrailingZero((abs / 1e5).toFixed(2))}L`;
  if (abs >= 1e3) return `${sign}${_stripTrailingZero((abs / 1e3).toFixed(1))}k`;
  return `${sign}${abs.toLocaleString("en-IN")}`;
};

export const fmtNum = (n) => Number(n || 0).toLocaleString("en-IN");

export const fmtDate = (s) => {
  if (!s) return "-";
  return new Date(s).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const fmtDateTime = (s) => {
  if (!s) return "-";
  return new Date(s).toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const fmtDateShort = (s) => {
  if (!s) return "-";
  return new Date(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
};
